module.exports = __webpack_public_path__ + "img/create-icon.1cca3265.svg";